import { useQuery } from '@apollo/client';
import { GET_COMPANIES } from '@bechtel/client-gql';
import { CompanyInput, PagingInput } from '@bechtel/types';
import { Company } from '../../users/list/drawer/company-list/types';

export function useCompanyQuery(input: CompanyInput, pagingInput: PagingInput) {
  const response = useQuery<{ companies: Company[] }, { input: CompanyInput; pagingInput: PagingInput }>(
    GET_COMPANIES,
    {
      variables: {
        input,
        pagingInput,
      },
    }
  );
  return response;
}
